import React from 'react'
import './table-row-active-badge.scss'
import { Radio } from 'antd'
import { CheckCircleFilled } from '@ant-design/icons'

const TableRowActiveBadge = (isActive: boolean) => (
    <span className="table-row-active-badge">
        {isActive ? <CheckCircleFilled /> : <Radio style={{ pointerEvents: 'none' }} checked={false} />}
    </span>
)

export default TableRowActiveBadge
